import { createSlice } from "@reduxjs/toolkit";

// this is a redux slice for the video player to store the video url and the playVideo flag
const readerVideoSlice = createSlice({
    name: 'readerVideo',
    initialState: {
        videoURL: null,
        playVideo: false,
        donePlaying: false,
        replaying: false,
        playing: false,
        replayEnabled: false,
    },
    reducers: {
        playVideo: (state) => {
            state.playVideo = true;
            state.playing = true;
            state.donePlaying = false;
        },
        replayVideo: (state) => {
            state.playVideo = true;
            state.replaying = true;
            state.playing = true;
            state.donePlaying = false;
        },
        pauseVideo: (state) => {
            state.playing = false;
        },
        stopVideo: (state) => {
            state.playing = false;
            state.donePlaying = true;
            state.replaying = false;
            state.playVideo = false;
        },
        replaceVideo: (state, action) => {
            state.videoURL = action.payload;
        },
        enableReplay: (state) => {
            state.replayEnabled = true;
        },
        disableReplay: (state) => {
            state.replayEnabled = false;
        },
        resetEverything: (state) => {
            state.videoURL = null;
            state.playVideo = false;
            state.donePlaying = false;
            state.replaying = false;
            state.playing = false;
            state.replayEnabled = false;
        }
    },
});

// export actions
export const { playVideo, 
    replayVideo, 
    pauseVideo, 
    replaceVideo, 
    stopVideo,
    enableReplay,
    disableReplay,
    resetEverything } = readerVideoSlice.actions;

// export the reducer
export default readerVideoSlice.reducer;

// export a selector to get the state
export const selectReaderVideo = state => state.readerVideo;